import React from 'react';

const About = ({ header, text, callToActionText }) => {
    return (
        <div className='mt-8 mx-4'>
            <h1 className='text-about_headerColor text-xl font-bold text-center underline'>קצת עליי</h1>
            <div dir="rtl" className="text-about_textColor text-lg font-medium text-center mx-auto sm:max-w-[700px]">
                <div className="my-2">
                    <p className="mt-2">
                        הגעתי לתחום היופי וקוסמטולוגיה לפני 5 שנים במקביל לקריירה ארוכה של אחות טיפול נמרץ בבית חולים עם אהבה עמוקה לאנשים ורצון לתמוך ולעזור להם להתמודד עם בעיות בריאות ולעשות הכל כדי שהאדם יחזור לחיים טובים.
                    </p>
                    <p className="mt-2">
                        יש לי ניסיון רב בתחום של בריאות, ידע מקצועי בתחום של אנטומיה, פיזיולוגיה ורפואה מתקדמת.
                    </p>
                    <p className="mt-2">
                        אני עובדת בשיתוף פעולה עם רופאים בתחומים שונים, שיכולים להיות קשורים לבעיות עור.
                    </p>
                    <p className="mt-2">
                        חשוב לי מאוד שתהיי מרוצה מאיך שאת נראית, תרגישי יפה עם עצמך ומקובלת בחברה.
                    </p>
                    <p className="mt-2">
                        חשוב לי שלא תצטרכי להשתמש באיפור, כדי להסתיר את מה שאת לא אוהבת בעור הפנים שלך ותרגישי עם עצמך יפה בכל גיל.
                    </p>
                </div>
            </div>

            <p dir='rtl' className='text-about_callToActionTextColors text-lg font-bold text-center mx-auto mt-4'>{callToActionText || 'צרו קשר בקליק'}</p>
        </div>
    );
};

export default About;
